"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("@emotion/react/jsx-runtime");
const react_redux_1 = require("react-redux");
const _1 = require(".");
function QnAList() {
    const comments = (0, react_redux_1.useSelector)((state) => state.comments);
    return ((0, jsx_runtime_1.jsx)(jsx_runtime_1.Fragment, { children: comments.map((question, index) => ((0, jsx_runtime_1.jsx)(_1.Question, { question: question }, `question_${index}_${question.id}`))) }));
}
exports.default = QnAList;
